var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListUl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#555;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.429,18.7a.915.915,0,0,1,.929-.9H26.071a.9.9,0,1,1,0,1.8H9.357A.915.915,0,0,1,8.429,18.7Zm0-7.2a.915.915,0,0,1,.929-.9H26.071a.9.9,0,1,1,0,1.8H9.357A.915.915,0,0,1,8.429,11.5Zm0-7.2a.915.915,0,0,1,.929-.9H26.071a.9.9,0,1,1,0,1.8H9.357A.915.915,0,0,1,8.429,4.3ZM2.857,6.1A1.829,1.829,0,0,0,4.714,4.3,1.829,1.829,0,0,0,2.857,2.5,1.829,1.829,0,0,0,1,4.3,1.829,1.829,0,0,0,2.857,6.1Zm0,7.2a1.8,1.8,0,1,0,0-3.6,1.8,1.8,0,1,0,0,3.6Zm0,7.2a1.8,1.8,0,1,0,0-3.6,1.8,1.8,0,1,0,0,3.6Z",
    transform: "translate(-1 -2.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListUl);
export default __webpack_public_path__ + "static/media/list-ul.317cb45bdead384e7eda4a84a9c5c661.svg";
export { ForwardRef as ReactComponent };